import { forwardRef } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';

import { ARROW_COLOR, PopupAlign, PopupPosition, PopupProps } from './Popup.types';

const Popup = forwardRef<HTMLElement, PopupProps>(
  (
    {
      children,
      isOpen,
      content,
      onClickOutside,
      containerPosition = PopupPosition.BOTTOM,
      alignContent = PopupAlign.CENTER,
      arrowColor = ARROW_COLOR.LIGHT,
      containerClassName = '',
      parentElementRef,
    },
    ref,
  ) => {
    return (
      <Popover
        ref={ref}
        parentElement={parentElementRef ?? undefined}
        isOpen={isOpen}
        onClickOutside={onClickOutside}
        positions={[containerPosition]}
        align={alignContent}
        reposition
        containerClassName={containerClassName}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={arrowColor}
            arrowSize={8}
          >
            {content}
          </ArrowContainer>
        )}
      >
        {children}
      </Popover>
    );
  },
);

export default Popup;
